import { Chip, Box } from "@mui/material";
import { stageColor } from "../theme/brand";

/** Chip de etapa del pipeline: mismo color que su columna en el tablero, texto siempre legible. */
export default function StageChip({ etapa, label, size = "small", sx }) {
  const color = stageColor(etapa);
  return (
    <Chip
      size={size}
      variant="outlined"
      label={label}
      icon={<Box component="span" sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: color, ml: "8px !important" }} />}
      sx={{ borderColor: color, color: "text.primary", bgcolor: "background.paper", ...sx }}
    />
  );
}
